"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Checkbox.scss");

require("./CheckboxDark.scss");

var _classNames = _interopRequireDefault(require("../../../util/classNames"));

var _CheckboxContext = require("./CheckboxContext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CheckAll = function CheckAll(props) {
  var _useState = (0, _react.useState)(props.checked),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var classes = (0, _classNames["default"])({
    disabled: props.disabled,
    checked: checked
  });

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      isCheckAll = _useState4[0],
      setIsCheckAll = _useState4[1];

  var _useContext = (0, _react.useContext)(_CheckboxContext.Context),
      _useContext2 = _slicedToArray(_useContext, 9),
      onCheckAll = _useContext2[3],
      checkAllValue = _useContext2[5],
      checkedIds = _useContext2[6],
      checkboxIds = _useContext2[8];

  (0, _react.useEffect)(function () {
    if (checkAllValue !== checked) {
      props.onChange(checkAllValue);
      setChecked(checkAllValue);
    }

    if (checkedIds.length === checkboxIds.length) {
      setIsCheckAll('-checked');
    } else if (checkAllValue) {
      setIsCheckAll('-line');
    } else {
      setIsCheckAll('');
    }
  }, [checkAllValue, checkedIds.length, checkboxIds.length]);
  (0, _react.useEffect)(function () {
    if (checked !== props.checked) {
      if (!props.disabled) {
        props.onChange(!checked);
        onCheckAll && onCheckAll(!checked);
        setChecked(!checked);
      }
    }
  }, [props.checked]);

  var onChange = function onChange(e) {
    e.stopPropagation();

    if (!props.disabled) {
      props.onChange(!checked);
      onCheckAll && onCheckAll(!checked);
      setChecked(!checked);
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-check ".concat(props.className, " ").concat(classes),
    onClick: onChange
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "checkbox",
    disabled: props.disabled,
    id: "checkall-id-".concat(props.id),
    name: "checkall-".concat(props.id),
    checked: checked,
    onChange: props.onChange
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-check-item ".concat(props.captionPosition)
  }, props.threeStates ? /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon checkbox".concat(isCheckAll, " ")
  }) : /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon checkbox".concat(checked ? '-line' : '', " ")
  })), props.icon && /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon ".concat(props.icon, " ").concat(props.iconSize, " glc-check-icon")
  }), /*#__PURE__*/_react["default"].createElement("span", null, props.caption));
};

CheckAll.defaultProps = {
  onChange: function onChange() {},
  className: '',
  captionPosition: 'right',
  icon: '',
  iconSize: '',
  threeStates: false
};
CheckAll.propTypes = {
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  onChange: _propTypes["default"].func.isRequired,
  caption: _propTypes["default"].string,
  checked: _propTypes["default"].bool,
  captionPosition: _propTypes["default"].oneOf(['left', 'right']),
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  icon: _propTypes["default"].string,
  iconSize: _propTypes["default"].oneOf(['small', 'large', '']),
  threeStates: _propTypes["default"].bool
};
var _default = CheckAll;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/Input/CheckBox/CheckAll.js
// module id = 1904
// module chunks = 0